import { days } from "../../cpcoc/days";
import { months } from "../../cpcoc/months";
import { dataOnce } from "../../main/data/data-read-only";
// let readingID: string;
let readingPlan;
export function getReadingPlan() {
    return readingPlan;
}
export function setReadingPlan(id) {
    if (!readingPlan) {
        console.warn("new call to database");
        return dataOnce(`bible-reading/${id}`).then((plan) => {
            readingPlan = plan;
            readingPlan.list = readingPlan.list.filter((d) => d); // remove empty items
            return readingPlan;
        });
    }
    return Promise.resolve(readingPlan);
}
export function getPlanTemplates() {
    return readingPlan === null || readingPlan === void 0 ? void 0 : readingPlan.templates;
}
export function getPlanByDate(date = new Date()) {
    // how is this dateNow different from the others?
    // can we just use currentDate?
    const dateNow = new Date(date);
    const dayIndex = dateNow.getDay();
    dateNow.setHours(0, 0, 0);
    let planData = {
        dayIndex: dayIndex,
        day: days[dayIndex],
        month: months[dateNow.getMonth()],
        year: dateNow.getFullYear(),
        dateNow,
    };
    if (!readingPlan) {
        return planData;
    }
    const startDate = new Date(readingPlan.startDate);
    const endDate = readingPlan.endDate && new Date(readingPlan.endDate);
    const isExpired = endDate && endDate < dateNow;
    const notStarted = startDate > dateNow;
    const workingDate = isExpired ? endDate : dateNow;
    const weekLength = days.length;
    const schedule = readingPlan.schedule.indexes;
    const list = readingPlan.list;
    const dayms = 1000 * 60 * 60 * 24;
    const daysSinceStart = Math.floor((workingDate.valueOf() - startDate.valueOf()) / dayms) +
        startDate.getDay();
    const weeksSinceStart = Math.floor(daysSinceStart / weekLength);
    const completedReadingsSinceStart = weeksSinceStart * schedule.length;
    const timesThroughPlan = completedReadingsSinceStart / list.length;
    const weekStartIndex = (completedReadingsSinceStart % list.length) - 1;
    const progress = timesThroughPlan - Math.floor(timesThroughPlan);
    const scheduleDayIndex = schedule.indexOf(dayIndex);
    const index = weekStartIndex + (scheduleDayIndex > -1 ? scheduleDayIndex : 0);
    planData = Object.assign(Object.assign({}, planData), { scheduleDayIndex,
        weeksSinceStart,
        weekStartIndex,
        progress,
        index,
        startDate,
        endDate });
    if (isExpired || notStarted) {
        return planData;
    }
    const currentPlan = scheduleDayIndex > -1 ? list[index] : undefined;
    let nextPlan;
    let previousWeekPlan;
    let nextWeekPlan;
    let previousPlan;
    // Are we past the first week?
    if (startDate.valueOf() + dayms * (days.length - startDate.getDay()) <=
        dateNow.valueOf()) {
        // use the weekStartIndex of the current week unless we are on a multiple time through the plan and it's the first week then we want to set it to the last week of the previous iteration.
        previousWeekPlan =
            list[(weekStartIndex || list.length) - (schedule.length - 1)];
    }
    // are we before the last day?
    if (!endDate || endDate.valueOf() + dayms * 1 <= dateNow.valueOf()) {
        // like the previous week we want to start over if within range still
        nextPlan = list[index >= list.length ? 0 : index + 1];
    }
    return Object.assign(Object.assign({}, planData), { weekLesson: currentPlan ? currentPlan.lesson : (nextPlan === null || nextPlan === void 0 ? void 0 : nextPlan.lesson) || "", weekTitle: currentPlan ? currentPlan.title : (nextPlan === null || nextPlan === void 0 ? void 0 : nextPlan.title) || "", currentPlan,
        nextPlan,
        previousWeekPlan,
        nextWeekPlan,
        previousPlan });
}
